export default __webpack_public_path__ + "static/media/usaa.1b86ba75.svg";